import { useMemo } from 'react';
import type { CprPanelMode } from './cprPanelTypes';

export function useCprPanelIdentity(className?: string) {
  return useMemo(() => {
    const [, main, modeKey] = className?.split('-') ?? [];
    if (!main || !modeKey) {
      return [0, undefined, ''] as [number, CprPanelMode | undefined, string];
    }

    const mode: CprPanelMode = modeKey === 'S' ? 'straightened' : 'stretched';
    return [Number(main), mode, `CPR.${main}.${mode}`] as [
      number,
      CprPanelMode,
      string,
    ];
  }, [className]);
}
